import { useLocation, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { FunctionComponent, PropsWithChildren, useContext, useEffect, useState } from 'react';
import { UserDetailsContext } from '../context/user-details/user-details';

const Partner: FunctionComponent<{ children?: PropsWithChildren }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const userDetailsContext = useContext(UserDetailsContext);

  const [isLoading, setIsLoading] = useState(true);
  const [canAccess, setCanAccess] = useState(false);

  useEffect(() => {

    setIsLoading(true)
    setCanAccess(false)

    async function checkAuth() {
      setIsLoading(true);
      setCanAccess(false);

      let userDetails = userDetailsContext.userDetails;

      if (!userDetails) {
        userDetails = await userDetailsContext.forceUpdateUserDetails();
      }

      if (userDetails) {
        //Eventually get rid of this, just while don't have a dashboard
        if (location.pathname === '/partner-dashboard') {
          navigate('/partner-clients')
        }
        if (userDetails.isPartner && userDetails.isLoggedInAsClient) {
          navigate('/dashboard')
        }
        if (userDetails.isPartner) {
          setCanAccess(true);
          setIsLoading(false);
        }
        else {
          setIsLoading(false)
        }
      }
      else {
        setIsLoading(false)
      }
    }

    checkAuth()

  }, [window.location.pathname])

  return isLoading ? null : canAccess ? <Outlet /> : <Navigate to="/dashboard" state={{ from: location }} replace />;
}

export default Partner;
